import React from 'react';
import { LoginCallback } from '@okta/okta-react';

const AuthOktaCallback = () => {
	return <LoginCallback />;
};

export default AuthOktaCallback;
